<template>
    <b-modal
            v-model="show"
            @hide="close(false)"
            centered
            size="md"
            title="Смена фотографии профиля"
    >
        <v-container fluid class="p-0">
            <v-row no-gutters>
                <v-col class="px-4 pb-4">
                    <imageLoader :ratioH="1" :editedImage="userAvatar" textLabel="" @file-loaded="logoLoaded"></imageLoader>
                </v-col>
            </v-row>
        </v-container>
        <template v-slot:modal-footer>
            <div class="w-100">
                <v-row no-gutters  justify="space-between">

                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="mr-2">
                        <v-btn
                                color="var(--color-blue)"
                                dark
                                size="sm"
                                @click="changeAvatar"
                        >
                            Сохранить
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn
                                class="cancel-btn"
                                outlined
                                color="var(--color-3)"
                                size="sm"
                                @click="close(false)"
                        >
                            Отмена
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex';
    import imageLoader from './ImageLoader.vue'
    import axios from 'axios';
    const apiLink=process.env.VUE_APP_API_LINK
    export default {
        name: "ChangeAvatarModal",
        components:{imageLoader},
        props:{
            show:Boolean
        },
        data(){
            return {
                newAvatar:null
            }

        },
        computed:{
            ...mapGetters({
                webUserInfo:"userData/getWebUser"
            }),

            userAvatar(){
                var user= this.webUserInfo;
                if(user!=null)
                {
                    return user.webUserLogo
                }
                else return null
            },


        },
        methods:{
            close(isSave){
                this.$emit('close', isSave)
            },

            logoLoaded(e){
                this.newAvatar=e[0]
                if(e[0]==null)
                    this.newAvatar=null
            },

            async changeAvatar(){
                console.log(this.newAvatar)
                //загружаем аватар на сервер
                if (this.newAvatar != null) {
                    //модель изменения аватарки пользователя
                    let logoModel={
                        identityId:this.webUserInfo.identityId,
                        newLogoId:null
                    };
                    const vm=this;
                    var imgId = null;
                    const imgData = new FormData();
                    imgData.append('files', this.newAvatar);
                    await axios.post(`${apiLink}FileUpload`, imgData)
                        .then(response => imgId = response.data[0])
                        .catch(error => {
                            console.log(error)
                        });
                    if (imgId != null)
                        logoModel.newLogoId = imgId;

                    this.$store.dispatch("userData/changeWebUSerLogo", logoModel).then((data)=>{
                        this.$bvToast.toast('', {
                            title: `Аватар обновлен`,
                            variant: "success",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                        this.close(true)
                    }).catch((err) => {
                        this.$bvToast.toast(err.message, {
                            title: `Ошибка изменения аватара!`,
                            variant: "danger",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    });
                }
            },
        }
    }
</script>

<style scoped>

</style>